import React, { useEffect } from "react";
import {
  Route,
  Routes,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import useUserStore from "./utils/storeApp";
import AppRoutes from "./AppRoutes";
import "./assets/sass/AppPortal.min.css";
/*import Footer from "./components/shared/Footer";*/
//theme
import "primereact/resources/themes/lara-light-indigo/theme.css";
//core
import "primereact/resources/primereact.min.css";
//icons
import "primeicons/primeicons.css";

const App = () => {
  const { SetSharedObject } = useUserStore((state) => ({
    SetSharedObject: state.SetSharedObject,
  }));
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (window !== "undefined") {
      if (location.pathname === "/ResetPassword") {
        let ob = {
          UserId: searchParams.get("userId"),
          Code: searchParams.get("code"),
          Type: "ResetPassword",
        };
        SetSharedObject("ResetPasswordObj", ob);
        navigate("/reset-password");
      } else {
        let flag = false;
        AppRoutes.map((route, index) => {
          if (location.pathname === route.path) {
            flag = true;
          }
        });
        if (!flag && location.pathname !== "/webmail") {
          navigate("/request-not-found");
        }
      }
    }
  }, []);
  return (
    <div>
      <Routes>
        {AppRoutes.map((route, index) => {
          const { element, ...rest } = route;
          return <Route key={index} {...rest} element={element} />;
        })}
      </Routes>
    </div>
  );
};
export default App;
